import { instance } from "../api/axiosInstance";
export async function getAppDashboardConfig(cityId) {
	return instance.get(`/cities/${cityId}/dashboard`);
}

export async function postAppDashboardConfig(cityId, data) {
	return instance.post(`/cities/${cityId}/dashboard`, data);
}

export const createServicesHeidi = (body) => {
	return instance.post(`/services`, body);
}

export const AddlogocoverHeidi = (serviceId,body) => {
	return instance.post(`/services/${serviceId}`, body);
}

export const getServicesHeidi = (id) => {
	return instance.get(`/cities/${id}/services`);
}